// extracted by mini-css-extract-plugin
module.exports = {"root":"PointEntry_root__gIjne","first":"PointEntry_first__19Gsz","index":"PointEntry_index__3jx0H","student":"PointEntry_student__2s0SS","value":"PointEntry_value__1pnS1"};